import React from "react"
import { OptionButton } from "../../section/utils/option-button"

export function VerticalAlign({ properties, update }) {
  return (
    <div>
      <div className="font-semibold text-gray-700 mb-1">Vertical alignment</div>
      <div className="flex border rounded mb-2">
        <div className="p-1 flex items-center justify-center flex-grow border-r">
          <OptionButton
            active={properties.verticalAlign === "top"}
            onClick={() => update({ verticalAlign: "top" })}
          >
            Top
          </OptionButton>
          <OptionButton
            active={properties.verticalAlign === "middle"}
            onClick={() => update({ verticalAlign: "middle" })}
          >
            Middle
          </OptionButton>
          <OptionButton
            active={properties.verticalAlign === "bottom"}
            onClick={() => update({ verticalAlign: "bottom" })}
          >
            Bottom
          </OptionButton>
        </div>
      </div>
    </div>
  )
}
